// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import {
  getAllServicesIaBalance,
  getServicesIaBalanceById,
} from '../../services/services-ia-balance.service';
import {
  setServicesIaBalanceListRedux,
  setServicesIaBalanceActiveRedux,
} from './servicesIaBalanceSlice';
import { QueryPagination } from '../../commons/interfaces';

export const getAllServicesIaBalanceStore =
  (query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response: any = await getAllServicesIaBalance(query);

      if (response.ok) {
        dispatch(setServicesIaBalanceListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const getServicesIaBalanceByIdStore = (id: string) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response: any = await getServicesIaBalanceById(id);

    if (response.ok) {
      dispatch(setServicesIaBalanceActiveRedux(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};
